import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./nav-pane-content.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./nav-pane-content.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { NavConstants } from "../nav.constants";
import { AppControllerService } from "../../../app-controller.service";
import { Router } from "@angular/router";
import { UserInformationService } from "../../../shared/services/user/user-information.service";
import { AuthService } from "../../../shared/services/auth/auth.service";
import { SystemModuleSettingsService } from "../../../shared/services/system-module-settings.service";
import { CreateApplicationRoutingConstants } from "../../../create-application/create-application-routing.constants";
import { SearchApplicationsRoutingConstants } from "../../../search-applications/search-applications-routing.constants";
import { CommonPopUpComponent } from "../../../../../../afla-common/src/lib/components/common-pop-up/common-pop-up.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedConstants } from "../../../shared/constants/shared.constants";
import { SelectedApplicationService } from "../../../shared/services/selected-application/selected-application.service";
import { SubscriberComponent } from "../../../shared/components/subscriber/subscriber.component";
import { NavPanService } from "./nav-pan.service";
import { DocumentsAndInformationRoutingConstants } from "../../../documents-and-information/documents-and-information-routing.constants";
import { SessionStorageService } from "../../../shared/services/storage/session-storage.service";
import { LocalStorageEnum } from "../../../shared/services/storage/local-storage-constants";
import { ApplicationCreateService } from "../../../create-application/shared/application-create.service";
import { AppConfig } from "../../../app.config";
export let NavPaneContentComponent = class NavPaneContentComponent extends SubscriberComponent {
    userInformationService;
    appControllerService;
    authService;
    router;
    applicationCreateService;
    sessionStorageService;
    changeDetectorRef;
    selectedApplicationService;
    systemModuleSettingsService;
    navService;
    modalService;
    modulesLink = AppRoutingConstants.ROUTE_SEPERATOR;
    homeLinkText = NavConstants.HOME_LINK_TEXT;
    logoutLinkText = NavConstants.LOGOUT_LINK_TEXT;
    settingLinks;
    addOrganisationLink;
    toolsMapLinks = new Array();
    organisationId;
    activeId = "";
    selectedModuleID;
    isAuthenticated = false;
    isSystemModuleSettingsFetched = false;
    selectMunicipalityText = NavConstants.SELECT_MUNICIPALITY_CITY;
    municipalities = [];
    selectedMunicipality;
    applicationTypes;
    selectedApplicationType;
    applications = [];
    selectMunicipalityLabel = NavConstants.SELECT_MUNICIPALITY_LABEL;
    selectApplicationLabel = NavConstants.SELECT_APPLICATION_LABEL;
    viewDocumentationText = NavConstants.VIEW_DOCUMENTATION_TEXT;
    createApplicationText = NavConstants.CREATE_APPLICATION_TEXT;
    searchMyApplicationText = NavConstants.SEARCH_MY_APPLICATION_TEXT;
    settingView = "Setting";
    municipalitiesView = "municipalities";
    defaultApplicantAgent = NavConstants.DEFAULT_APPLICANT_AGENT_TEXT;
    selectAnOptionText = NavConstants.PLEASE_SELECT_AN_OPTION;
    menuMode = this.municipalitiesView;
    logo = "";
    selectStatus;
    switchToStatusModule = false;
    displaySelectedModule;
    loadedApplicationTypesMap = new Map();
    systemModuleLinks;
    displayOrgSettings = false;
    dialogTitle = NavConstants.INCOMPLETE_APPLICATIONS_TITLE;
    dialogMessage = NavConstants.INCOMPLETE_APPLICATIONS_MESSAGE;
    modalBodyOptions = {
        size: "lg",
        centered: true,
        backdrop: "static"
    };
    constructor(userInformationService, appControllerService, authService, router, applicationCreateService, sessionStorageService, changeDetectorRef, selectedApplicationService, systemModuleSettingsService, navService, modalService) {
        super();
        this.userInformationService = userInformationService;
        this.appControllerService = appControllerService;
        this.authService = authService;
        this.router = router;
        this.applicationCreateService = applicationCreateService;
        this.sessionStorageService = sessionStorageService;
        this.changeDetectorRef = changeDetectorRef;
        this.selectedApplicationService = selectedApplicationService;
        this.systemModuleSettingsService = systemModuleSettingsService;
        this.navService = navService;
        this.modalService = modalService;
        this.listenForSystemModules();
    }
    ngOnInit() {
        this.subscribeToConfigSubject();
        this.loadMunicipalities();
        this.listenForAuthentication();
        this.listenForModuleFetch();
        this.buildSettingLinksList();
        this.mapToolsLinksList();
        this.buildAddLinks();
        this.getAuthUserName();
        this.showDefaultModule();
        this.listenForRefresh();
        this.selectApplication();
    }
    logout() {
        this.authService.logOutRedirect();
        //this.authService.unAuthenticate();
    }
    goBackToModules() {
        this.menuMode = this.municipalitiesView;
        this.displayOrgSettings = false;
    }
    onSearchApplicationClicked() {
        this.router.navigate([
            AppRoutingConstants.createRouteToView(SearchApplicationsRoutingConstants.SEARCH_APPLICATIONS_ROUTE)
        ]);
    }
    selectApplication() {
        this.appControllerService.selectedApplicationM$.subscribe(select => {
            this.displaySelectedModule = select;
            this.switchToStatusModule = !this.switchToStatusModule;
            this.changeDetectorRef.detectChanges();
        });
    }
    onCreateApplicationClicked() {
        this.appControllerService.setSelectedModule(this.selectedModuleID);
        this.checkIncompleteApplications(false);
    }
    checkIncompleteApplications(eLodgementComplete) {
        this.cleanupAfterDestroy(this.userInformationService.hasOpenPortalApplications(Number(this.appControllerService.selectedModuleID))).subscribe(result => {
            if (result.value === true) {
                this.openIncompleteApplicationsDialog();
            }
            else {
                this.proceedToCreateApplications();
            }
        });
    }
    onViewDocumentationClicked() {
        this.router.navigate([
            AppRoutingConstants.createRouteToView(this.appControllerService.selectedModuleID, DocumentsAndInformationRoutingConstants.VIEW_DOCUMENTS_AND_INFORMATION_ROUTE)
        ]);
    }
    selectMunicipality(event) {
        const input = event.target.value;
        this.selectedApplicationType = null;
        this.applicationTypes = null;
        if (!input) {
            return;
        }
        this.selectedMunicipality = this.municipalities.find(m => m.id === +input);
        if (!this.selectedMunicipality)
            return;
        this.appControllerService.selectedOrganisationID(this.selectedMunicipality.id);
        this.getApplicationTypes(this.selectedMunicipality.id);
    }
    selectApplicationType(event) {
        const input = event.target.value;
        this.selectedApplicationType = null;
        if (!input)
            return;
        this.selectedApplicationType = this.applicationTypes.find(m => m.id === +input);
        if (!this.selectedApplicationType)
            return;
        this.selectedModuleID = this.selectedApplicationType.id;
        this.appControllerService.setSelectedModule(this.selectedApplicationType.id);
        this.router.navigate(["/"]);
    }
    proceedToCreateApplications() {
        this.selectedApplicationService.setSelectedApplication(null);
        this.sessionStorageService.remove(LocalStorageEnum.SelectedJobID);
        this.sessionStorageService.set(LocalStorageEnum.SelectedModuleID, this.appControllerService.selectedModuleID);
        this.selectedApplicationService.setIncompleteJobId(0);
        this.applicationCreateService.setSelectGoToStep(0);
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
            this.router.navigate([AppRoutingConstants.createRouteToView(this.appControllerService.selectedModuleID, CreateApplicationRoutingConstants.CREATE_APPLICATION_ROUTE)]);
        });
    }
    openIncompleteApplicationsDialog() {
        const dialogRef = this.modalService.open(CommonPopUpComponent, this.modalBodyOptions);
        dialogRef.componentInstance.title = this.dialogTitle;
        dialogRef.componentInstance.contentMessage = this.dialogMessage;
        dialogRef.componentInstance.updateBtnPlaceholder = SharedConstants.OK_LABEL;
        dialogRef.componentInstance.cancelBtnPlaceholder = SharedConstants.CANCEL_LABEL;
        dialogRef.componentInstance.data = true;
        dialogRef.result.then((proceed) => {
            this.changeDetectorRef.markForCheck();
            if (proceed) {
                this.proceedToCreateApplications();
            }
            else {
                this.onSearchApplicationClicked();
            }
        });
    }
    listenForSystemModules() {
        this.systemModuleLinks = new Array();
    }
    buildSettingLinksList() {
        this.settingLinks = new Array();
        this.settingLinks.sort((a, b) => 0 - (a.address.toLowerCase() > b.address.toLowerCase() ? -1 : 1));
    }
    mapToolsLinksList() {
        this.toolsMapLinks = new Array();
    }
    buildAddLinks() {
        this.addOrganisationLink = {
            text: NavConstants.ADD_ORGANISATION_LINK_TEXT,
            address: AppRoutingConstants
                .createRouteToViewWithPrefixRouteSeparator(AppRoutingConstants.ADD_ORGANISATION_ROUTE)
        };
    }
    showDefaultModule() {
        // function will show all modules by default if user has only 1 organisation assigned
        const activePanel = "panel-0";
        this.activeId = activePanel;
    }
    listenForAuthentication() {
        this.cleanupAfterDestroy(this.authService.$isAuthenticated).subscribe(result => {
            this.isAuthenticated = result;
            this.changeDetectorRef.detectChanges();
        });
    }
    getAuthUserName() {
        // shows link to test site for component should be removed post testing
        this.cleanupAfterDestroy(this.userInformationService.$authenticatedUser).subscribe(user => {
            this.changeDetectorRef.detectChanges();
        });
    }
    loadMunicipalities() {
        this.cleanupAfterDestroy(this.authService.$isAuthenticated).subscribe(connected => {
            if (connected)
                this.cleanupAfterDestroy(this.navService.getMunicipalities()).subscribe(mun => {
                    this.municipalities = mun;
                    this.appControllerService.organisations = this.municipalities;
                    if (this.municipalities.length === 1) {
                        this.selectedMunicipality = this.municipalities[0];
                        this.getApplicationTypes(this.selectedMunicipality.id);
                        this.appControllerService.selectedOrganisationID(this.municipalities[0].id);
                    }
                });
        });
    }
    getApplicationTypes(municipalityId) {
        if (this.loadedApplicationTypesMap.has(municipalityId)) {
            this.applicationTypes = this.loadedApplicationTypesMap.get(municipalityId);
            if (this.applicationTypes.length === 1) {
                this.selectedApplicationType = this.applicationTypes[0];
                this.appControllerService.setSelectedModule(this.selectedApplicationType.id);
            }
        }
        else {
            this.cleanupAfterDestroy(this.navService.getApplicationTypes(municipalityId)).subscribe(appType => {
                this.applicationTypes = appType;
                this.appControllerService.modules = this.applicationTypes;
                if (this.applicationTypes.length === 1) {
                    this.selectedApplicationType = this.applicationTypes[0];
                    this.appControllerService.setSelectedModule(this.selectedApplicationType.id);
                }
                this.loadedApplicationTypesMap.set(municipalityId, this.applicationTypes);
                this.changeDetectorRef.detectChanges();
            });
        }
    }
    listenForRefresh() {
        this.appControllerService.applicationRefreshedSubject.subscribe((applicationRefreshed) => {
            if (applicationRefreshed) {
            }
        });
    }
    subscribeToConfigSubject() {
        this.appControllerService.$configLoadedSubject.subscribe((configLoaded) => {
            if (configLoaded) {
                this.logo = AppConfig.settings.logoUrl;
                this.changeDetectorRef.detectChanges();
            }
        });
    }
    listenForModuleFetch() {
        this.cleanupAfterDestroy(this.systemModuleSettingsService.$systemModuleSettingsFetched).subscribe(result => {
            this.isSystemModuleSettingsFetched = result;
            this.changeDetectorRef.detectChanges();
        });
    }
    static ctorParameters = () => [
        { type: UserInformationService },
        { type: AppControllerService },
        { type: AuthService },
        { type: Router },
        { type: ApplicationCreateService },
        { type: SessionStorageService },
        { type: ChangeDetectorRef },
        { type: SelectedApplicationService },
        { type: SystemModuleSettingsService },
        { type: NavPanService },
        { type: NgbModal }
    ];
};
NavPaneContentComponent = __decorate([
    Component({
        selector: "app-nav-pane-content",
        providers: [],
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], NavPaneContentComponent);
